import './styles.scss';

import MobileApp from './MobileApp';

export default MobileApp;
